export default __webpack_public_path__ + "static/media/guess.cf0e1b89.jpg";